import { LoaderCircle } from "lucide-react";
import type { HTMLAttributes, ReactNode } from "react";

export type LoadingIndicatorProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
  size?: "sm" | "md" | "lg";
};

const SIZE_CLASSES = {
  sm: "h-3.5 w-3.5",
  md: "h-4 w-4",
  lg: "h-5 w-5",
} as const;

export function LoadingIndicator({ children = "Carregando...", className = "", role = "status", size = "md", ...props }: LoadingIndicatorProps) {
  return (
    <div
      {...props}
      role={role}
      className={`flex items-center gap-2 text-[var(--fz-loading-text)] ${className}`}
    >
      <LoaderCircle aria-hidden="true" className={`${SIZE_CLASSES[size]} shrink-0 animate-spin text-[var(--fz-loading-spinner)]`} />
      <span>{children}</span>
    </div>
  );
}
